// removed by extract-text-webpack-plugin
module.exports = {"fadeUp":"commons__fadeUp___2LX2X","lateFadeUp":"commons__lateFadeUp___3MQZz","lateFadeIn":"commons__lateFadeIn___3ngRy"};


//////////////////
// WEBPACK FOOTER
// ./client/styles/commons.scss
// module id = 957
// module chunks = 0